export const YASTORE_B2B_ROUTE_PATHS = {
    settingsAbout: '/settings/about',
    settingsLogistics: '/settings/logistics',
} as const;

const ROUTE_PATH_PLACEHOLDER_PATTERN = /\{\{yastoreB2BRoutePath:([^}]+)\}\}/g;

type YastoreB2BRoutePathName = keyof typeof YASTORE_B2B_ROUTE_PATHS;

const isYastoreB2BRoutePathName = (value: string): value is YastoreB2BRoutePathName =>
    Object.prototype.hasOwnProperty.call(YASTORE_B2B_ROUTE_PATHS, value);

/**
 * Подставляет пути B2B в строки, которые не могут импортировать TypeScript-константы напрямую, например JSDoc.
 * Плейсхолдер: `{{yastoreB2BRoutePath:settingsAbout}}`.
 */
export const resolveYastoreB2BRoutePathPlaceholders = (value: string): string =>
    value.replace(ROUTE_PATH_PLACEHOLDER_PATTERN, (_placeholder, pathName: string) => {
        if (!isYastoreB2BRoutePathName(pathName)) {
            throw new Error(`Unknown Yastore B2B route path: ${pathName}`);
        }

        return YASTORE_B2B_ROUTE_PATHS[pathName];
    });
